
 

 

 

    import PublicNewsCriteria from 'Modules/Aqs/Scripts/AppServiceContract/PublicNewsCriteria';

    import PagingCriteria from 'Lib/Fs.Core.Data/PagingCriteria';

 
class PublicNewsSearchParameter 
{
    
        Criteria: PublicNewsCriteria;
    
        SortingCriteria: any;
    
        PagingCriteria: PagingCriteria;
    
}
 
export default PublicNewsSearchParameter;
 




